export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ evgSkuStatus, applicationStatus }) => {
      return !!(
        ['D'].includes(evgSkuStatus) ||
        (applicationStatus && ['P','O'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ evgSkuStatus, applicationStatus }) => {
      return !!(
        ['Y', 'D'].includes(evgSkuStatus) ||
        (applicationStatus && ['P','O'].includes(applicationStatus))
      )
    },
  },
  {
    text: that.$l('btn_print_tag') || '标签打印',
    icon: 'el-icon-printer',
    menuType: 'print',
    divided: true,
    allow: 'P',
    disabled: ({ evgSkuStatus }) => !['Y'].includes(evgSkuStatus),
  },
]
